import React, { useEffect, useState } from 'react';
import { getUser } from '@myapp/common-web-sdk';
import { headIconAPI } from '../../services/api';
import './UserHeadIcon.css';

const UserHeadIcon = ({ user, className = '' }) => {
  const currentUser = user || getUser();
  const [imageURL, setImageURL] = useState('');
  const userID = currentUser?.id || currentUser?.user_id || currentUser?.uid || currentUser?.sub;
  const label = currentUser?.user_name || currentUser?.real_name || currentUser?.username || '用户';

  useEffect(() => {
    if (!userID) return undefined;
    let active = true;
    let objectURL = '';

    headIconAPI.get()
      .then((response) => {
        if (!active) return;
        objectURL = URL.createObjectURL(response.data);
        setImageURL(objectURL);
      })
      .catch(() => {});

    return () => {
      active = false;
      if (objectURL) URL.revokeObjectURL(objectURL);
    };
  }, [userID]);

  if (!currentUser) return null;

  return (
    <a
      href={`${window.location.origin}/account-center/profile`}
      className={`user-head-icon ${className}`.trim()}
      title="进入个人资料"
      aria-label="进入个人资料并管理头像"
    >
      {imageURL
        ? <img src={imageURL} alt="" />
        : <span>{label.charAt(0).toUpperCase()}</span>}
    </a>
  );
};

export default UserHeadIcon;

